import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, importCSS } from '../../lib/ep.js';
import { size as _size } from 'lodash';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import { Checkbox } from '../builder/Checkbox';
import DigitImage from '../builder/DigitImage';
import EmailField from '../builder/EmailField';
import FieldLabel from '../builder/FieldLabel';
import Input from '../builder/Input';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import FloatingLayerPublic from '../front/FloatingLayerPublic';

import EasypromosLiveLogo from '../svg/EasypromosLiveLogo';

const RoundedButton = (props) => {
	var Component = null;
	switch(props.component_type) {
		case 'save':
			Component = SaveButton;
			break;
		case 'link':
			Component = ActionLink;
			break;
		case 'button':
		default:
			Component = ActionButton;
			break;
	}

	var new_props;
	if(props.main_color != undefined) {
		new_props = {...props, color:'variable', _class:{...props._class}, style:{background:props.main_color}};
	} else {
		new_props = {...props, color:'black', _class:{...props._class}};
	}

	new_props.component_type = null;
	new_props.children = null;

	return (
		<div class="gui_rounded_bordered_button">
			<Component {...new_props}>{props.children}</Component>
		</div>
	)
}

const Wrapper = (props) => {
	const on_counter_ends = (props.on_counter_ends != undefined) ? props.on_counter_ends : null;
	const extra_classes = (props.extra_classes != undefined) ? ' ' + props.extra_classes : '';
	const is_login = (props.is_login != undefined) ? ' ' + props.is_login : false;

	const title = (props.title != undefined && props.title != '') ? props.title : false;
	const organizer = (props.organizer != undefined && props.organizer != '') ? props.organizer : false;

	return (
		<section class={'gui_live_contest' + ((is_login) ? ' is_login' : '')} style={{background:props.main_color}}>
			<article class={'contents' + extra_classes}>
				{(title || organizer) && (
					<div class="floating_info">
						{(title) && (
							<h1 class="title">{title}</h1>
						)}
						{(organizer) && (
							<p class="organizer">{organizer}</p>
						)}
					</div>
				)}

				{props.children}
			</article>
		</section>
	)
}

class SweepsLiveEvent extends Component {
	//Constructor
	constructor(props, context) {
		super(props, context);

		this.state = {
			actual_question:false,
			//display_save_status:false,
			errors:{},
			index_question:-1,//On Init
			game_pin:'',
			message_register:null,
			mode_incognito:false,
			next_enabled:false,
			values:props.values,
			success_register:null,
			show_disconnect:false,
			submitted_form:false,
			submitting_form:false,
			submitted_email:false,
			submitting_email:false,
			time_countdown_start:-1,
			user:{},
			display_policy:false,
		}

		this.questions = props.questions;
		this.inputname = props.inputname;
		this.has_user_started = false;
		this.has_user_finished = false;
		this.need_email = props.values.email != undefined ? props.values.email : false;
	}

	componentWillMount() {
		importCSS('comp/live_contest.css');
	}

	componentDidMount() {
		this.register_start();

		isPrivate((isPrivate) => {
			this.setState({ mode_incognito:false });
			//this.setState({ mode_incognito:isPrivate });
		});
	}

	tryAgain() {
		this.state.user={};
		this.state.actual_question = false;
		this.state.index_question = -1;
		this.state.submitted_form=false;
		this.state.submitted_email=false;
		this.state.message_register=null;
		this.state.success_register=null;
		this.state.next_enabled=false;
		this.setState({...this.state});
	}

	changePin(k, v) {
		this.state.errors = {};
		this.state[k] = v;
		this.setState({...this.state});
	}

	/*stateStatus(result) {
		this.state.display_save_status = (result.status) ? 'ok' : 'ko';
		this.setState({ ...this.state });
	}*/


	register_start(){
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const values = this.props.values;
		const sweep_id = values.id;
		var cookie_participation = getCookie('in_live_'+sweep_id);
		if(cookie_participation){
			var cookie = cookie_participation.split('@@@@@');
			this.state['user']['name'] = cookie[1];
			this.state['user']['position'] = cookie[2];
			this.state['user']['time'] = cookie[3];
			this.state.show_disconnect = true;
			this.state.success_register = 1;
			this.state.message_register = i18n("Thanks for joining");
			this.has_user_finished =true;
			this.setState({...this.state});
		}else if(values.start != undefined && values.start > 0){
			this.has_user_started = true;
			this.setState({...this.state});
		}
	}

	start_game(cb) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const sweep_id = this.state.values.id;

		var data = {};
		data.action = 'register_start';

		$.ajax({
			url:getRemotedbUrl(`/action/${sweep_id}/${data.action}`),
			data:data,
			async:true,
			dataType:'json',
			type:'POST',
			success:(response) => {
				if(response.status) {
					//Iniciat
					this.has_user_started = true;
					this.state.values = response.values;
				} else if(response.cookie!=undefined) {
					var cookie = (response.cookie).split('@@@@@');
					this.state['user']['name'] = cookie[1];
					this.state['user']['position'] = cookie[2];
					this.state['user']['time'] = cookie[3];
					this.state.values = response.values;
					this.state.success_register = 1;
					this.state.message_register = i18n("Thanks for joining");
				} else if(response.out_limit!=undefined) {
					this.state['user']['time'] = 0;
				} else {
					//alert("The contest has not started yet");
				}
				this.setState({...this.state});
				if(cb != undefined) cb();
			},
		});
	}

	changeUser(k, v) {
		var splitted_value = k.split(':');
		if(splitted_value[0] == 'question') {
			if(this.state['user'][splitted_value[0]] == undefined) this.state['user'][splitted_value[0]] = {};
			this.state['user'][splitted_value[0]][splitted_value[1]] = v;
		} else {
			this.state['user'][k] = v;
		}

		if(this.state['user']['name'] != undefined && this.state['user']['name'] != '' && _size(this.state['user']['name']) >= 3) {
			if(this.need_email && this.state.submitting_email){
				if(this.state['user']['email'] != undefined && validateEmail(this.state['user']['email']) && this.state['user']['accept_toc'] != undefined && this.state['user']['accept_toc']) {
					this.state.next_enabled = true;
				}else{
					this.state.next_enabled = false;
				}
			}else{
				this.state.next_enabled = true;
			}
		} else {
			this.state.next_enabled = false;
		}

		if(this.state.index_question > 0 && this.state.submitted_form && !this.state.submitting_email) {
			const question_number = this.state.index_question;
			const questions = (this.questions != undefined && _size(this.questions) > 0) ? this.questions : false;

			if(questions) {
				var actual_question = questions[question_number];
				if(this.state['user']['question'] == undefined || this.state['user']['question'][question_number] == undefined) {
					this.state.next_enabled = false;
				}
			}
		}

		this.setState({...this.state});
	}

	validateEmail(passed) {
		if(!passed){
			this.state.errors['email'] = "Wrong email format.";
		}else{
			delete this.state.errors['email'];
		}
		this.setState({...this.state});
	}

	auto_end(cb) {
		if(this.state.user.name != undefined && this.state.user.question != undefined && _size(this.state.user.question) == _size(this.questions)) {
			//autosubmit
			this.setState({...this.state});
			this.nextQuestion(cb);
		}
	}

	selectAnswer(question_number, answer, cb) {
		this.changeUser('question:' + question_number, answer.value);
		this.nextQuestion(cb);
	}

	disconnect(cb) {
		var domain = location.hostname,
			path = '/'; // root path
		var name = 'in_live_' + this.state.values.id;

		document.cookie = [
			name, '=',
			'; expires=' + new Date(0).toUTCString(),
			'; path=' + path,
			'; domain=' + domain
		].join('');

		window.location.reload();
	}

	togglePolicy() {
		this.state.display_policy = !this.state.display_policy;
		this.setState({...this.state});
	}

	nextQuestion(cb) {
		if(this.state.submitted_form || _size(this.questions) == 0) {
			var next_index_question = parseInt(this.state.index_question) + 1;
			if(_size(this.questions) > next_index_question) {
				if(cb != undefined) cb(true, '', () => {
					this.setState({ index_question:next_index_question });
				});
			} else {

				if(this.need_email && !this.state.submitting_email){
					if(cb != undefined) cb(true, '', () => {
						this.state.next_enabled = false;
						this.state.submitting_email = true;
						this.state.index_question = next_index_question;
						this.setState({...this.state});
					});
				}else{

					this.setState({ submitting_form:true });

					//Stop && send
					const sweep_id = this.state.values.id;
					var data = {};
					data.action = 'register';
					data.user = this.state.user;

					$.post(getRemotedbUrl(`/action/${sweep_id}/${data.action}`), data, (result) => {
						if(cb != undefined) cb();
						this.state.submitting_form = false;
						if(result.out_limit != undefined) {
							this.state.message_register = result.message;
							this.state.success_register = result.status;
						} else {
							this.state.user.position = result.position;
							this.state.user.name = result.name;
							this.state.user.time = result.time_finish;
							this.state.message_register = result.message;
							this.state.success_register = result.status;
						}
						this.has_user_finished =true;
						this.setState({...this.state});
					}, 'json');
				}
			}
		} else {
			this.state.submitted_form = true;
			var next_index_question = parseInt(this.state.index_question) + 1;
			if(_size(this.questions) > next_index_question) {
				this.state.index_question = next_index_question;
			}
			if(cb != undefined) cb();
			this.setState({...this.state});
		}
	}

	check_game(cb) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const sweep_id = this.state.values.id;

		var start_time = new Date().getTime();

		var data = {};
		data.action = 'check';
		data.game_pin = this.state.game_pin;

		$.post(getRemotedbUrl('/check'), data, (result) => {
			if(!result.status) {
				//alert(result.message);
				this.state.errors['game_pin']=result.message;
				this.state.game_pin='';
				if(cb != undefined) cb();
				//this.stateStatus(result);
				this.setState({...this.state});
			} else {
				this.has_user_started = true;
				if(result.cookie != undefined) {
					var cookie = result.cookie.split('@@@@@');
					this.state['user']['name'] = cookie[1];
					this.state['user']['position'] = cookie[2];
					this.state['user']['time'] = cookie[3];
					this.state.values = result.setup!=undefined ? result.setup : result.values;
					this.state.show_disconnect = true;
					this.state.success_register = 1;
					this.state.message_register = i18n("Thanks for joining");
					this.has_user_finished =true;
				}else{
					window.location.href = window.sweepslive_url + result.values.id;
				}
				this.setState({...this.state});
			}
			
		}, 'json');
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const values = this.state.values;
		const is_registration_open = this.has_user_started;
		const is_registration_submitted = (this.state.success_register != undefined) ? true : false;
		const has_contest_started = values.start != undefined && values.start > 0;
		const has_contest_finished = this.has_user_finished || (values.end && values.end < values.now);
		const is_outlimit = values.out_limit;
		const is_registration_process_initiated = ((has_contest_started && !has_contest_finished) || (has_contest_started)) ? true : false;
		const question_number = this.state.index_question;
		const questions = (question_number>=0 && this.questions != undefined && _size(this.questions) > 0) ? this.questions : false;
		const has_next_question = (_size(questions) > parseInt(question_number) + 1) ? true : false;
		const in_process_email = (!has_next_question && this.state.submitting_email) ? true : false;

		const title = values.title!=undefined ? values.title : false;
		const organizer = values.organizer!=undefined ? values.organizer : false;


		if(this.state.mode_incognito) {
			return (
				<Wrapper title={title} organizer={organizer}>
					<div class="messages">
						<img src="https://media2.giphy.com/media/26gJyLzXIR388sCqY/giphy.gif" />
					</div>
				</Wrapper>
			)
		}

		if(is_outlimit && !is_registration_submitted) {
			return (
				<Wrapper main_color={values.main_color}>
					<div class="messages">
						<p>{i18n("Limit of participants exceeded")}</p>
					</div>
				</Wrapper>
			)
		}

		if(values.id == undefined) {
			return (
				<Wrapper extra_classes="gui_flex_center" is_login={true}>
					<EasypromosLiveLogo />
					<Model classname="real_contents" model={this.state} change={(k, v) => this.changePin(k, v)} errors={this.state.errors}>
						<Input type="number" key="pin" name="game_pin" placeholder="Game PIN" _class={{first:true, other:'gui_big_input'}}/>
					</Model>
					<ButtonCollection _class={{other:'gui_full_width'}}>
						<RoundedButton main_color="rgba(60, 70, 200, 1)" time="200" component_type="save" onClick={(e, cb) => this.check_game(cb)}>Enter</RoundedButton>
					</ButtonCollection>
					<aside class="by_easypromos">
						<FormattedMessage id="Create you own {live_giveaway_link} with {ep_link}" values={{live_giveaway_link:<span><ActionLink _href="https://www.easypromosapp.com/" _target="_blank">Giveaway for events</ActionLink><br /></span>, ep_link:<ActionLink _href="https://www.easypromosapp.com/" _target="_blank">Easypromos</ActionLink>}} />
					</aside>
				</Wrapper>
			)
		}

		if(!is_registration_open && !is_registration_submitted) {
			return (
				<Wrapper title={title} organizer={organizer} main_color={values.main_color} extra_classes="gui_flex_center">
					<ButtonCollection _class={{other:'gui_full_width'}}>
						<RoundedButton component_type="save" onClick={(e, cb) => this.start_game(cb)}>Start</RoundedButton>
					</ButtonCollection>
				</Wrapper>
			)
		}

		if(is_registration_submitted) {
			const user = this.state.user;
			const participation_time = parseInt(user.time) - parseInt(values.start); // seconds

			const participation_min = Math.floor(participation_time / 60);
			const participation_sec = Math.round(participation_time % 60);

			//UTMs REMOVED TO INCREASE SEO BEST PRACTICES:
			const live_landing_link = 'https://live.easypromosapp.com/' + ((window.is_spanish) ? 'sorteo-en-evento' : 'giveaways-for-events');
			//const live_landing_link = 'https://live.easypromosapp.com/' + ((window.is_spanish) ? 'sorteo-en-evento' : 'giveaways-for-events') + '/?utm_source=easypromos&utm_medium=app_promos&utm_campaign=footer_sweep&utm_content=s8_event-giveaway';

			return (
				<Wrapper main_color={values.main_color}>
					<div class="messages">
						<span>{this.state.message_register}</span>
						{(this.state.success_register == '1') && (
							<div class="participant_resumee">
								<div>
									<span>{i18n("You entered as")}:</span>
									<span class="registered_username">
										<span class="gui_pos_rel">
											<span class="gui_cutTextOnOverflow">{user.name}</span>
										</span>
									</span>
								</div>
								{/*
								<div>
									<span>{i18n("Your unique number")}:</span>
									<span class="registered_username">
										<span class="gui_inline_block">
											<DigitImage value={user.position} />
										</span>
									</span>
								</div>
								*/}

								<div>
									<span>{i18n("Your time")}:</span>
									<span class="registered_username">
										<span class="gui_inline_block">
											<span class="time gui_pos_rel gui_flexbox_auto gui_flex_row">
												<DigitImage value={(participation_min < 10) ? ('0' + participation_min) : participation_min} />
												<span class="is_separator"><DigitImage value={"colon"} /></span>
												<DigitImage value={(participation_sec < 10) ? ('0' + participation_sec) : participation_sec} />
											</span>
										</span>
									</span>
								</div>
							</div>
						)}

						{(this.state.success_register == '1') && (
							<div class="participant_alert_message">
								<div class="is_message">{i18n("Please, keep this window opened. If you win the contest, you will need to show it to the organizer.")} 😎</div>

								<div>
									<p class="created_with">{i18n("Giveaway created with")}:</p>
									<ActionLink _href={live_landing_link} _target="_blank">
										<EasypromosLiveLogo />
									</ActionLink>
								</div>

								{(this.state.show_disconnect) && (
									<ActionLink onClick={() => this.disconnect()} _class={{other:'gui_underlined_text'}}>Disconnect</ActionLink>
								)}
							</div>
						)}
					</div>
				</Wrapper>
			)
		}

		if(has_contest_finished) {
			return (
				<Wrapper main_color={values.main_color}>
					<div class="messages">
						<p>{i18n("This event has ended, wait for results!")}</p>
					</div>
				</Wrapper>
			)
		}

		const actual_question = (questions) ? questions[question_number] : false;
		var label_submit_button = (has_next_question) ? "Next question" : this.state.submitting_email || !in_process_email ? "Finalize" : "Continue";
		if(!this.state.submitted_form && !this.state.submitting_email) label_submit_button = "Continue";

		return (
			<Wrapper on_counter_ends={() => this.auto_end()} main_color={values.main_color}>
				{(is_registration_process_initiated && !actual_question && !in_process_email) && (
					<div class="real_contents">
						<Input
							model={this.state.user}
							change={(k, v) => this.changeUser(k, v)}
							value={this.state.user.name}
							name="name"
							_class={{first:true, other:'gui_big_input'}}
							autotranslate={false}
							placeholder={this.inputname}
						/>

						<p class="gui_text_align_center gui_not_in_top_tiny">{i18n("Emoji friendly")} 😊</p>
					</div>
				)}

				{(is_registration_process_initiated && !actual_question && in_process_email) && (
					<div class="real_contents">
						<Model model={this.state.user} change={(k, v) => this.changeUser(k, v)} errors={this.state.errors}>
							<EmailField
								name="email"
								_class={{first:true, other:'gui_big_input'}}
								passed={this.validateEmail.bind(this)}
								error_msg_position_class={"is_floating"}
								autotranslate={false}
								placeholder={"Your email adress"}
							/>

						</Model>

						<p class="gui_text_align_center gui_not_in_top_tiny" style={{lineHeight:'1.4em', fontSize:'12pt'}}>{this.need_email.disclaimer}</p>

						<Model model={this.state.user} change={(k, v) => this.changeUser(k, v)} errors={this.state.errors}>
							<Checkbox
								name="accept_toc"
								autotranslate={false}
							><FormattedMessage id="I accept {link}" values={{ link:<ActionLink onClick={(e, cb) => this.togglePolicy()}>Privacy Policy</ActionLink> }} /></Checkbox>
						</Model>

						{this.state.display_policy && (
							<FloatingLayerPublic
								backButton={() => this.togglePolicy()}
								title={`<h1>${i18n("Privacy Policy")}</h1>`}
								_class={{other:'live_toc_layer whiteBg'}}
							>
								<iframe src={this.need_email.policy} style={{ width:'100%', height:'100%' }} />
							</FloatingLayerPublic>
						)}
					</div>
				)}

				{(is_registration_process_initiated && actual_question && !in_process_email) && (
					<div class="real_contents live_question">
						<FieldLabel _class={{first:true, other:'question_title without_colon'}}>{actual_question.question.text}</FieldLabel>
						<div class="question_container">
							<ul class="question_answers">
								{actual_question.answers.map((answer, i) => {
									return (
										<li key={i}>
											<RoundedButton
												disabled={(this.state.submitting_form) ? true : false}
												time={250}
												component_type="save"
												onClick={(e,cb) => this.selectAnswer(question_number, answer, cb)}
												autotranslate={false}
											>{answer.label}</RoundedButton>
										</li>
									)
								})}
							</ul>
						</div>
					</div>
				)}

				{(is_registration_process_initiated && (actual_question === false || in_process_email)) && (
					<ButtonCollection _class={{other:'gui_full_width'}}>
						<RoundedButton component_type="save" disabled={(!this.state.next_enabled) ? true : false} onClick={(e, cb) => this.nextQuestion(cb)}>{label_submit_button}</RoundedButton>
					</ButtonCollection>
				)}
			</Wrapper>
		)
	}
}

export default injectIntl(SweepsLiveEvent);